module.exports = __webpack_public_path__ + "img/52.046e81af.jpg";